import type { IntegrationProviderCategory } from "@app/common/types";

export const INTEGRATION_CATEGORIES: {
  category: IntegrationProviderCategory;
  title: string;
  description: string;
}[] = [
  {
    category: "calendar",
    title: "Calendar",
    description:
      "Allow Read to join your meetings and automatically generate meeting summaries",
  },
  {
    category: "productivity",
    title: "Productivity",
    description: "Generate Readouts from your inbox or channels",
  },
  {
    category: "messaging",
    title: "Messaging",
    description: "Share and receive meeting summaries",
  },
  {
    category: "crm",
    title: "CRM",
    description: "Sync your CRM system with meeting notes and contacts",
  },
  {
    category: "workflow",
    title: "Workflow",
    description: "Integrate Read into your favorite apps",
  },
];
